<div style="display: flex; flex-direction: row;justify-content:space-between;">
  <div class="rfq-create-form" [ngClass]="{ 'full-width-container1': !showDetailSection, 'half-width-container1': showDetailSection }" style="display: flex; flex-direction: column;overflow-x: hidden;">
      <div class="rfq-create-form-title">

          <div style="display: flex;flex-direction:row;justify-content:space-between;margin-top:10px;margin-bottom:5px">
              <div id="createquotation">
                View Purchase Order
              </div>
              <button mat-button color="primary"
                    style="font-size:18px; padding-left: 32px; padding-right: 32px; padding-top: 24px; padding-bottom: 24px;"
                    (click)="close(true)">Close<mat-icon>navigate_next</mat-icon></button>
          </div>
      </div>

      <div class="col-xl-10 col-lg-9 col-9 p-0 card-body-fixheight z-index-4" style="width: 100%;">
          <mat-card class="p-0" style="margin: 0 0.5rem">
              <mat-card-content class="ship-fscoll hgt ship-pr-sec">
                  <nav mat-tab-nav-bar class="tagGroup">
                      <a mat-tab-link *ngFor="let tabItem of tabs; let idx = index"
                          [class.active-link]="currentTab === tabItem.route" class="teb_icon"
                          (click)="selectMatTabLink(tabItem)">
                          <span id="navstepstext">{{tabItem.label}}</span>
                      </a>
                  </nav>

                  <div class="mat-tab-body-content pos-relative">

                      <div>
                          <div style="display: flex;justify-content: space-between;align-items: center;margin-top:30px">
                            <div>
                              <form [formGroup]="secondFormGroup">
                                <div class="form-item-row" style="flex-direction: column-reverse;">
                                    <div style="display: flex; flex-direction: column; width: 100%; height:  100%;">
                                        <label>Preferred Currency<span class="required-star" style="color: red;margin-left: 2px;">*</span></label>
                                        <app-paginated-autocomplete-manual style="background-color: white!important; margin-bottom: 10px; color: white!important;" [displayWithFunc]="filterFieldCurrencyNameDisplayFn"
                                        [dataSrc]="boundGetCurrencyAutoComplete" [controlName]="'supplierCurrency'" [control]="getCurrencyControl()"
                                        [readonly]="true" >
                                    </app-paginated-autocomplete-manual>
                                    </div>
                                    <small *ngIf="secondFormGroup || secondFormGroup['controls']['supplierCurrency']['dirty'] || secondFormGroup['controls']['supplierCurrency']['touched']" class="form-error-msg">
                                        <div style="padding:2px;" *ngIf="secondFormGroup.controls['supplierCurrency'].hasError('required')">
                                            *Currency should not be empty.
                                        </div>
                                    </small>
                                    <small class="form-error-msg" style="color: blue;">
                                      <div style="padding:2px;" >
                                        1 {{ secondFormGroup.get('supplierCurrency')?.value?.currencyCode || 'No Currency' }} = 1 {{headerData?.currencyId?.currencyCode}}
                                       ( as of {{currentdate }})
                                      </div>
                                  </small>
                                </div>

                              </form>
                            </div>


                            <!-- <div  style="display: flex;justify-content: flex-end;padding-top: 28px;">
                                <div class="wrap-description-toggle">
                                    <mat-slide-toggle (change)="toggleWrapDescription($event)">Wrap Description</mat-slide-toggle>
                                </div>
                                <div class="dropdown-container">
                                  <button mat-fab class="green-button" [matMenuTriggerFor]="columnsMenu" matTooltip="Show more columns">
                                    <mat-icon>add</mat-icon>
                                  </button>
                                  <mat-menu #columnsMenu="matMenu">
                                    <button mat-menu-item *ngFor="let col of dynamicColumns" (click)="showColumn(col)">
                                      <mat-checkbox [checked]="col.visible">{{ col.name }}</mat-checkbox>
                                    </button>
                                  </mat-menu>
                                </div>
                            </div> -->
                          </div>
                          <div style="display: flex; flex-direction: column; overflow-x: auto; width: 100%;margin-top:70px">

                              <form [formGroup]="lineItemtableForm">

                                <ngx-datatable
                                  #table
                                  class="material expandable"
                                  [rows]="dataSource"
                                  [headerHeight]="50"
                                  [footerHeight]="50"
                                  [rowHeight]="'auto'"
                                  [columnMode]="'force'"
                                  [scrollbarH]="true"
                                  [externalPaging]="false"
                                  [externalSorting]="false"
                                  [limit]="10"
                                  >

                                  <ngx-datatable-column name="S.No." [width]="100">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <input matInput [formControl]="lineItemtableForm.get('rows')['controls'][rowIndex].get('position')" readonly style="width: 40px;"
                                      [matTooltip]="getDeclineReason(rowIndex)" [matTooltipDisabled]="!isDecline(rowIndex)"/>
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column name="Service Name">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <input matInput [formControl]="lineItemtableForm.get('rows')['controls'][rowIndex].get('serviceName')" readonly
                                      [matTooltip]="getDeclineReason(rowIndex)" [matTooltipDisabled]="!isDecline(rowIndex)"/>
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column name="Service Description">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <textarea matInput [formControl]="lineItemtableForm.get('rows')['controls'][rowIndex].get('serviceDescription')"
                                        [disabled]="true" readonly
                                        [ngClass]="{ 'expanded-input': isWrapDescription }"
                                        [rows]="isWrapDescription ? 4 : 1"
                                        matTooltipClass="mat-tooltip-custom"
                                        [matTooltip]="getDeclineReason(rowIndex)" [matTooltipDisabled]="!isDecline(rowIndex)"
                                        ></textarea>
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column name="Scope of Work">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <textarea matInput [formControl]="lineItemtableForm.get('rows')['controls'][rowIndex].get('scopeOfWork')"
                                        [disabled]="true" readonly
                                        [ngClass]="{ 'expanded-input': isWrapDescription }"
                                        [rows]="isWrapDescription ? 4 : 1"
                                        [matTooltip]="getDeclineReason(rowIndex)" [matTooltipDisabled]="!isDecline(rowIndex)" readonly
                                        ></textarea>
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column name="Supplier Comment">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <textarea matInput [formControl]="lineItemtableForm.get('rows')['controls'][rowIndex].get('supplierComment')"
                                        [ngClass]="{ 'expanded-input': isWrapDescription }"
                                        [rows]="isWrapDescription ? 4 : 1"
                                        readonly
                                        [matTooltip]="getDeclineReason(rowIndex)" [matTooltipDisabled]="!isDecline(rowIndex)"
                                        ></textarea>
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column name="Requested Quantity">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <input matInput [formControl]="lineItemtableForm.get('rows')['controls'][rowIndex].get('quantity')"
                                        [disabled]="true" readonly onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                        [matTooltip]="getDeclineReason(rowIndex)" [matTooltipDisabled]="!isDecline(rowIndex)"/>
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column  name="Quoted Quantity">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <input matInput [formControl]="lineItemtableForm.get('rows')['controls'][rowIndex].get('supplierQuantity')"
                                        (blur)="calculateRowValues(rowIndex)"
                                        onkeypress="return event.charCode >= 48 && event.charCode <= 57" readonly
                                        [matTooltip]="getDeclineReason(rowIndex)" [matTooltipDisabled]="!isDecline(rowIndex)"/>
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column name="Requested UOM">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <input matInput [formControl]="lineItemtableForm.get('rows')['controls'][rowIndex].get('uom')" readonly style="width: 100px;"
                                      [matTooltip]="getDeclineReason(rowIndex)" [matTooltipDisabled]="!isDecline(rowIndex)"/>
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column name="Quoted UOM">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <input matInput pattern="[A-Za-z\\s]*" style="width: 100px;" [formControl]="lineItemtableForm.get('rows')['controls'][rowIndex].get('supplierUom')" readonly  (keypress)="allowOnlyLetters($event)"
                                      [matTooltip]="getDeclineReason(rowIndex)" [matTooltipDisabled]="!isDecline(rowIndex)"/>
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column name="Quoted Unit Cost" [sortable]="true" [width]="220">
                                    <ng-template ngx-datatable-header-template let-column="column">
                                      <div class="datatable-header-flex">
                                        <span class="datatable-header-text">
                                          Quoted Unit Cost <span class="required-star">*</span>
                                        </span>

                                        <mat-slide-toggle
                                          (change)="getColumn('requestedUnitCost') ? showToggleColumns(getColumn('requestedUnitCost')) : null"
                                          [checked]="getColumn('requestedUnitCost')?.visible"
                                          class="ml-2">
                                        </mat-slide-toggle>

                                        <button mat-icon-button style="padding: 0px;"
                                          [matTooltip]="'Currency conversion is powered by ExchangeRate-API and locked at entry.'">
                                          <mat-icon>info</mat-icon>
                                        </button>

                                        <!-- This renders the built-in sort icon -->
                                        <span class="datatable-sort-icon" [class.active]="column.sort?.dir">
                                          <i [ngClass]="{
                                            'fa fa-caret-up': column.sort?.dir === 'asc',
                                            'fa fa-caret-down': column.sort?.dir === 'desc'
                                          }"></i>
                                        </span>
                                      </div>
                                    </ng-template>

                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <input type="number" matInput
                                        [formControl]="lineItemtableForm.get('rows')['controls'][rowIndex].get('unitCost')"
                                        (blur)="calculateRowValues(rowIndex)"
                                        [disabled]="true" step="any"
                                        readonly
                                        [matTooltip]="getDeclineReason(rowIndex)"
                                        [matTooltipDisabled]="!isDecline(rowIndex)" />
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column type='button' *ngIf="getColumn('requestedUnitCost')?.visible" name="Requested Price">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      {{headerData?.currencyId?.currencyCode}} {{ lineItemtableForm.get('rows')['controls'][rowIndex].get('requestedUnitCost').value | number: '1.3-3' }}
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column name="Discount">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <input type="number" matInput [formControl]="lineItemtableForm.get('rows')['controls'][rowIndex].get('discount')"
                                        (blur)="calculateRowValues(rowIndex)" step="any" readonly
                                        [matTooltip]="getDeclineReason(rowIndex)" [matTooltipDisabled]="!isDecline(rowIndex)"/>
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column name="Quoted Total Cost" [sortable]="true" [width]="220">
                                    <ng-template ngx-datatable-header-template let-column="column">
                                      <div class="datatable-header-flex">
                                        <span class="datatable-header-text">Quoted Total Cost</span>

                                        <mat-slide-toggle
                                          (change)="getColumn('requestedTotalCost') ? showToggleColumns(getColumn('requestedTotalCost')) : null"
                                          [checked]="getColumn('requestedTotalCost')?.visible"
                                          class="ml-2">
                                        </mat-slide-toggle>

                                        <button mat-icon-button style="padding: 0px;"
                                          [matTooltip]="'Currency conversion is powered by ExchangeRate-API and locked at entry.'">
                                          <mat-icon>info</mat-icon>
                                        </button>

                                        <span class="datatable-sort-icon" [class.active]="column.sort?.dir">
                                          <i [ngClass]="{
                                            'fa fa-caret-up': column.sort?.dir === 'asc',
                                            'fa fa-caret-down': column.sort?.dir === 'desc'
                                          }"></i>
                                        </span>
                                      </div>
                                    </ng-template>

                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <input type="number" matInput
                                        [formControl]="lineItemtableForm.get('rows')['controls'][rowIndex].get('totalCost')"
                                        [disabled]="true" step="any" readonly
                                        [matTooltip]="getDeclineReason(rowIndex)"
                                        [matTooltipDisabled]="!isDecline(rowIndex)" />
                                    </ng-template>
                                  </ngx-datatable-column>


                                  <ngx-datatable-column type='button' *ngIf="getColumn('requestedTotalCost')?.visible" name="Total Requested Price">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                        {{headerData?.currencyId?.currencyCode}} {{ lineItemtableForm.get('rows')['controls'][rowIndex].get('requestedTotalCost').value | number: '1.3-3' }}

                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column name="Lead Time">
                                    <ng-template ngx-datatable-header-template let-column="column">
                                      Lead Time <span class="required-star">*</span>
                                    </ng-template>
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <input type="number" matInput [formControl]="lineItemtableForm.get('rows')['controls'][rowIndex].get('leadTime')" style="width: 100px;" readonly
                                      [matTooltip]="getDeclineReason(rowIndex)" [matTooltipDisabled]="!isDecline(rowIndex)"/>
                                    </ng-template>
                                  </ngx-datatable-column>


                                  <!-- <ngx-datatable-column type='button' *ngIf="getColumn('attachments')?.visible" name="Attachments">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <button mat-icon-button (click)="toggleSidebar(true, 'attachment', rowIndex)" [disabled]="isDecline(rowIndex)">
                                        <mat-icon>add_circle</mat-icon>
                                      </button>
                                    </ng-template>
                                  </ngx-datatable-column> -->

                                  <!-- <ngx-datatable-column name="" [width]="80">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>

                                      <button type='button' *ngIf="!isDecline(rowIndex)" mat-icon-button class="delete-icon-button" (click)="toggleSidebar(true, 'decline', rowIndex)">
                                        <mat-icon>close</mat-icon>
                                      </button>

                                      <button type='button' *ngIf="isDecline(rowIndex)" mat-icon-button class="delete-icon-button" (click)="restoreLineitem(rowIndex)">
                                        <mat-icon>restore</mat-icon>
                                      </button>
                                    </ng-template>
                                  </ngx-datatable-column> -->
                                </ngx-datatable>
                              </form>

                              <!-- <button mat-raised-button color="primary" (click)="addNewLineItem()" style="width: 10%;">Add New Row</button> -->
                          </div>
                          <div [ngClass]="{ 'secondformcontainerfull': !showDetailSection, 'secondformcontainerhalf': showDetailSection }" style="margin: 30px;float:right;">
                            <!-- <form [formGroup]="secondFormGroup">
                              <div class="floating-card-container">
                                <div class="floating-card">
                                  <div style="display: flex; justify-content: space-between; align-items: center; padding: 10px 20px; font-weight: bold;">
                                    <span><b>Total <span *ngIf="secondFormGroup.get('supplierCurrency')?.value?.currencyCode!== null">
                                      ({{ secondFormGroup.get('supplierCurrency')?.value.currencyCode}})
                                    </span></b></span>
                                    <span>{{ (secondFormGroup.get('quoteLineItemTotal')?.value || 0) | number: '1.3-3' }}</span>
                                  </div>
                                  <div class="card-body mx-4">
                                     <div class="container">

                                        <div class="row">
                                          <hr>
                                          <div class="col-xl-10">
                                            <p>Line Item list Price Sub Total</p>
                                          </div>
                                          <div class="col-xl-2">
                                            <p class="float-end">
                                              <input type="text" matInput [value]="secondFormGroup.get('quoteLineItemListPriceSubtotal')?.value | number : '1.3-3'" readonly />
                                            </p>
                                          </div>
                                          <div class="col-xl-10">
                                            <p>Line Item Discount</p>
                                          </div>
                                          <div class="col-xl-2">
                                            <p class="float-end">
                                              <input type="text" matInput [value]="secondFormGroup.get('quoteLineItemDiscount')?.value | number : '1.3-3'" readonly />

                                            </p>
                                          </div>
                                          <div class="col-xl-10">
                                            <p><b>Line Item Sub Total</b></p>
                                          </div>
                                          <div class="col-xl-2">
                                            <p class="float-end">
                                              <input type="text" matInput [value]="secondFormGroup.get('quoteLineItemSubtotal')?.value | number : '1.3-3'" readonly />

                                            </p>
                                          </div>
                                          <hr>
                                        </div>
                                        <div class="row">
                                          <div class="col-xl-10">
                                            <p><b>General Discount</b></p>
                                          </div>
                                          <div class="col-xl-2">
                                            <p class="float-end">
                                              <select formControlName="quoteLineItemGeneralDiscountType" [disabled]="true" readonly style="width: 100%; margin-bottom: 10px;">
                                                <option value="percentage">Percentage</option>


                                                </select>
                                              <input type="number" matInput [formControlName]="'quoteLineItemGeneralDiscountValue'"  step="any"  (blur)="calculateCostSummary()" readonly/>

                                            </p>
                                          </div>
                                          <hr>
                                        </div>

                                        <div class="row">
                                          <div class="col-xl-10">
                                            <p><b>Applicable Tax Profile</b></p>
                                          </div>
                                          <div class="col-xl-2">
                                            <p class="float-end">
                                              <select formControlName="quoteLineItemApplicableTaxProfile" style="width: 100%; margin-bottom: 10px;" (change)="calculateCostSummary()" [disabled]="true">
                                                <option *ngFor="let item of taxStatusData" [value]="item.taxId">
                                                  {{ item.nameOfTaxProfile }} - {{ item.country?.name }} - {{ item.taxType }} ({{item.regionName}}) - {{ item.taxNumber }} - {{ item.taxPercentage }} %
                                                </option>
                                                </select>
                                              <input type="text" matInput [value]="secondFormGroup.get('quoteLineItemTaxAmount')?.value | number : '1.3-3'" readonly />

                                            </p>
                                          </div>
                                          <hr>
                                        </div>

                                        <div class="row">
                                          <div class="col-xl-10">

                                          </div>
                                          <div class="col-xl-2">
                                            <p class="float-end">


                                              <button mat-icon-button matTooltip="Remove Freight"
                                                          matTooltipPosition="below" (click)="toggleSidebar(true,'freight')">
                                                              <span style="color: red;background-color:white;display:flex;justify-content:center;align-items:center;border-radius:50%"><mat-icon>close</mat-icon></span>
                                                        </button>
                                            </p>

                                          </div>

                                          <div *ngIf="secondFormGroup.get('quoteLineItemFreight')?.value?.length > 0" >
                                            <div class="row" *ngFor="let item of secondFormGroup.get('quoteLineItemFreight')?.value">
                                              <div class="col-xl-10">
                                                <p class="mb-0"
                                                  [ngClass]="{ 'fw-bold': item.freightDescription?.trim()?.toLowerCase() === 'freight' }">
                                                  {{ item.freightDescription }}
                                                </p>
                                              </div>
                                              <div class="col-xl-2">
                                                  <p class="float-end" style="display: flex;justify-content: center;align-items: center;">
                                                    <input type="number" matInput [value]="item.freightValue" step="any" readonly />

                                                  </p>
                                              </div>
                                            </div>
                                          </div>

                                          <div style="display:flex;justify-content: flex-end;margin-bottom: 10px">
                                            <input type="number" matInput [formControlName]="'quoteLineItemFreightTotal'"  step="any" (blur)="calculateCostSummary()" readonly/>
                                          </div>
                                          <hr style="border: 1px solid white;">
                                        </div>
                                        <div class="row text-black">

                                          <div class="col-xl-12">
                                            <p class="float-end fw-bold" style="color: white !important;"> Total:
                                              <input type="number" matInput [formControlName]="'quoteLineItemTotal'" [disabled]="true" step="any" readonly />
                                            </p>
                                          </div>
                                          <hr style="border: 1px solid white;">
                                        </div>


                                      </div>
                                  </div>
                                </div>
                              </div>
                        </form> -->
                            <form [formGroup]="secondFormGroup">
                                <div class="floating-card-container">
                                  <div class="floating-card">
                                    <div
                                      style="display: flex; justify-content: space-between; align-items: center; padding: 10px 20px; font-weight: bold;"
                                    >
                                      <span>
                                        <b>
                                          Total
                                          <span
                                            *ngIf="secondFormGroup.get('supplierCurrency')?.value?.currencyCode !== null"
                                          >
                                            ({{ secondFormGroup.get('supplierCurrency')?.value.currencyCode }})
                                          </span>
                                        </b>
                                      </span>
                              <span>{{ (secondFormGroup.get('quoteLineItemTotal')?.value || 0) | number: '1.3-3' }}</span>
                                    </div>

                                    <div class="card-body mx-4">
                                      <div class="container">

                                        <div class="row">
                                          <hr />
                                          <div class="col-xl-10">
                                            <p>Line Item list Price Sub Total</p>
                                          </div>
                                          <div class="col-xl-2">
                                            <p class="float-end">
                                              <input type="text" matInput [value]="secondFormGroup.get('quoteLineItemListPriceSubtotal')?.value | number : '1.3-3'" readonly />
                                            </p>
                                          </div>

                                          <div class="col-xl-10">
                                            <p>Line Item Discount</p>
                                          </div>
                                          <div class="col-xl-2">
                                            <p class="float-end">
                                              <input type="text" matInput [value]="secondFormGroup.get('quoteLineItemDiscount')?.value | number : '1.3-3'" readonly />
                                            </p>
                                          </div>

                                          <div class="col-xl-10">
                                            <p><b>Line Item Sub Total</b></p>
                                          </div>
                                          <div class="col-xl-2">
                                            <p class="float-end">
                                              <input
                                                type="number"
                                                matInput
                                                [formControlName]="'quoteLineItemSubtotal'"
                                                [disabled]="true"
                                                step="any"
                                                readonly
                                              />
                                            </p>
                                          </div>
                                          <hr />
                                        </div>


                                        <div class="row">
                                          <div class="col-xl-10">
                                            <p><b>General Discount</b></p>
                                          </div>
                                          <div class="col-xl-2">
                                            <p class="float-end">
                                              <select
                                                formControlName="quoteLineItemGeneralDiscountType"
                                                [disabled]="true"
                                                readonly
                                                style="width: 100%; margin-bottom: 10px;"
                                              >
                                                <option value="percentage">Percentage</option>
                                              </select>
                                              <input
                                                type="number"
                                                matInput
                                                [formControlName]="'quoteLineItemGeneralDiscountValue'"
                                                step="any"
                                                (blur)="calculateCostSummary()"
                                                readonly
                                              />
                                            </p>
                                          </div>
                                          <hr />
                                        </div>


                                        <div class="row">
                                          <div class="col-xl-10">
                                            <p><b>Applicable Tax Profile</b></p>
                                          </div>
                                          <div class="col-xl-2">
                                            <p class="float-end">
                                              <select
                                                formControlName="quoteLineItemApplicableTaxProfile"
                                                style="width: 100%; margin-bottom: 10px;"
                                                (change)="calculateCostSummary()"
                                                [disabled]="true"
                                              >
                                                <option
                                                  *ngFor="let item of taxStatusData"
                                                  [value]="item.taxId"
                                                >
                                                  {{ item.nameOfTaxProfile }} -
                                                  {{ item.country?.name }} -
                                                  {{ item.taxType }}
                                                  ({{ item.regionName }}) -
                                                  {{ item.taxNumber }} -
                                                  {{ item.taxPercentage }} %
                                                </option>
                                              </select>
                                              <input type="text" matInput [value]="secondFormGroup.get('quoteLineItemTaxAmount')?.value | number : '1.3-3'" readonly />
                                            </p>
                                          </div>
                                          <hr />
                                        </div>


                                        <!-- <div class="row">
                                          <div class="col-xl-10">
                                            <p><b>Freight</b></p>
                                          </div>
                                          <div class="col-xl-2">
                                            <div class="float-end">
                                              <div
                                                class="freight-inline"
                                                *ngIf="
                                                  secondFormGroup.get('quoteLineItemFreight')?.value?.length > 0
                                                "
                                              >
                                                <ng-container
                                                  *ngFor="
                                                    let item of secondFormGroup.get('quoteLineItemFreight')
                                                      ?.value
                                                  "
                                                >
                                                  <input
                                                    type="number"
                                                    matInput
                                                    [value]="item.freightValue"
                                                    step="any"
                                                    readonly
                                                  />
                                                  <button
                                                    *ngIf="
                                                      item.freightDescription?.trim()?.toLowerCase() ===
                                                      'freight'
                                                    "
                                                    mat-icon-button
                                                    matTooltip="Remove Freight"
                                                    matTooltipPosition="below"
                                                    (click)="toggleSidebar(true, 'freight')"
                                                  >
                                                    <span>
                                                      <mat-icon>close</mat-icon>
                                                    </span>
                                                  </button>
                                                </ng-container>
                                              </div>
                                            </div>
                                          </div>
                                          <hr />

                                          <div class="col-xl-10">
                                            <p><b>Freight Total</b></p>
                                          </div>
                                          <div class="col-xl-2">
                                            <p class="float-end">
                                              <input
                                                type="number"
                                                matInput
                                                [formControlName]="'quoteLineItemFreightTotal'"
                                                step="any"
                                                (blur)="calculateCostSummary()"
                                                readonly
                                              />
                                            </p>
                                          </div>
                                          <hr style="border: 1px solid white;" />
                                        </div> -->

                                        <!-- Freight Section -->
                                        <div class="row">
                                          <div class="col-xl-12" *ngIf="secondFormGroup.get('quoteLineItemFreight')?.value?.length > 0">
                                            <div
                                              *ngFor="let item of secondFormGroup.get('quoteLineItemFreight')?.value"
                                              class="d-flex align-items-center justify-content-between mb-2"
                                            >
                                              <label class="fw-bold me-2" style="min-width: 100px;">
                                                {{ item.freightDescription }}
                                              </label>

                                              <div class="freight-wrapper freight-inline">
                                                <!-- <input
                                                  type="number"
                                                  matInput
                                                  [value]="item.freightValue"
                                                  step="any"
                                                  readonly
                                                /> -->
                                                <input
                                                  type="text"
                                                  matInput
                                                  [value]="item.freightValue | number : '1.3-3'"
                                                  readonly
                                                />

                                                <button
                                                  *ngIf="item.freightDescription?.trim()?.toLowerCase() === 'freight'"
                                                  mat-icon-button
                                                  matTooltip="Remove Freight"
                                                  matTooltipPosition="below"
                                                  (click)="toggleSidebar(true, 'freight')"
                                                  class="remove-btn"
                                                >
                                                  <span class="freight-icon-circle">
                                                    <mat-icon>close</mat-icon>
                                                  </span>
                                                </button>
                                              </div>
                                            </div>
                                          </div>

                                          <div class="col-xl-10">
                                            <!-- <p><b>Freight Total</b></p> -->
                                          </div>
                                          <div class="col-xl-2">
                                            <p class="float-end">
                                              <input
                                                type="number"
                                                matInput
                                                [formControlName]="'quoteLineItemFreightTotal'"
                                                step="any"
                                                (blur)="calculateCostSummary()"
                                                readonly
                                              />
                                            </p>
                                          </div>
                                          <hr style="border: 1px solid white;" />
                                        </div>

                                        <div class="row text-black">
                                          <div class="col-xl-12">
                                            <p
                                              class="float-end fw-bold"
                                              style="color: white !important;"
                                            >
                                              Total:
                                              <input
                                                type="number"
                                                matInput
                                                [formControlName]="'quoteLineItemTotal'"
                                                [disabled]="true"
                                                step="any"
                                                readonly
                                              />
                                            </p>
                                          </div>
                                          <hr style="border: 1px solid white;" />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </form>

                      </div>

                      </div>


                      <!-- add new decument -->
                      <!-- <div class="sidebar" style="overflow: auto;" *ngIf="showAddDocumentSection">
                        <div class="sidebar-title" style="justify-content: space-between; padding:15px 15px; ;">
                          <div class="sidebar-title-text">Add New Document</div>
                          <div style="display: flex; justify-content: right; width: 50%; gap: 10px;">
                            <span style="float: right;" class="pointer header-close-btn" matTooltipClass="mat-tooltip-custom" matTooltip="Close"
                              matTooltipPosition="below" (click)="toggleSidebar(false,'attachment')">
                              <mat-icon style="color: white;" >close</mat-icon>
                            </span>
                          </div>
                        </div>

                        <div class="sidebar-content">

                            <mat-form-field class="full-width" color="accent">
                              <mat-label>Document Type</mat-label>
                              <mat-select [(ngModel)]="selectedAttachmentType" (selectionChange)="onAttachmentTypeChange($event)">
                                <mat-option *ngFor="let item of lineItemAttachmentTypeData" [value]="item.id"> {{item.documentTypeDescription}}</mat-option>
                              </mat-select>
                            </mat-form-field>

                        <ngx-file-drop class="w100 file-drop-zone" dropZoneLabel="Drop files here" (onFileDrop)="onAttachmentChange($event)"
                        (onFileOver)="fileOver($event)" (onFileLeave)="fileLeave($event)" accept=".svg,.SVG,.png,.PNG,.jpeg,.JPEG,.jpg,.JPG,.pdf,.PDF">
                        <ng-template style="display: flex; flex-direction: row;" ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
                            <div class="drag-file">
                                <mat-icon>cloud_upload</mat-icon>
                                <p> Drag & drop the file here or </p>
                                <div class="" (click)="openFileSelector()">
                                    <p style="color:#74c5b5">upload a file</p>
                                </div>
                                <p> *PDF, JPG or PNG  </p>
                            </div>
                        </ng-template>
                    </ngx-file-drop>


                    <div *ngIf="getLineItemAttachment().length > 0 " style="display: flex; flex-direction: column;">
                      <h3 style="padding-top: 20px;"><b>Line Item Attachments</b></h3>
                      <div class="file-name-box" *ngFor="let file of getLineItemAttachment()">{{ file.name }}

                                <button mat-icon-button matTooltipClass="mat-tooltip-custom" matTooltip="View" matTooltipPosition="below" (click)="togglePreview(true,'single',file.dataUrl)">
                                  <mat-icon>visibility</mat-icon>
                              </button>


                      </div>
                  </div>



                            <div class="button-container">
                                <button type="button" class="save-button" (click)="toggleSidebar(false,'attachment')">
                                    <mat-icon>save</mat-icon>
                                </button>
                                <button type="button" class="close-button" (click)="toggleSidebar(false,'attachment')">
                                    <mat-icon>cancel</mat-icon>
                                </button>
                            </div>
                        </div>
                      </div> -->

                      <!-- add cost -->
                      <!-- <div class="sidebar" *ngIf="showAddCostSection">
                        <div class="sidebar-title" style="justify-content: space-between; padding:15px 15px; ;">
                          <div class="sidebar-title-text">Additional Cost</div>
                          <div style="display: flex; justify-content: right; width: 50%; gap: 10px;">
                            <span style="float: right;" class="pointer header-close-btn" matTooltipClass="mat-tooltip-custom" matTooltip="Close"
                              matTooltipPosition="below" (click)="toggleSidebar(false,'cost')">
                              <mat-icon style="color: white;" >close</mat-icon>
                            </span>
                          </div>
                        </div>

                        <div class="sidebar-content">

                          <mat-form-field class="full-width" color="accent" >
                            <mat-label>Additional Cost Description</mat-label>
                            <input matInput [(ngModel)]="freightDescription" placeholder="Enter the descritpion for the additional cost">
                        </mat-form-field>



                          <mat-form-field class="full-width" color="accent">
                            <mat-label>Value</mat-label>
                            <input matInput [(ngModel)]="freightValue" placeholder="Enter the value"
                             onkeypress="return event.charCode >= 48 && event.charCode <= 57">
                        </mat-form-field>

                            <div class="button-container">
                                <button type="button" class="save-button" (click)="saveAdditionalCost()">
                                    <mat-icon>save</mat-icon>
                                </button>
                                <button type="button" class="close-button" (click)="toggleSidebar(false,'cost')">
                                    <mat-icon>cancel</mat-icon>
                                </button>
                            </div>
                        </div>
                      </div> -->

                      <!-- decline -->
                      <!-- <div class="sidebar" style="overflow: auto;" *ngIf="showDeclineSection">
                        <div class="sidebar-title" style="justify-content: space-between; padding:15px 15px; ;">
                          <div class="sidebar-title-text">Decline to quote on line item</div>
                          <div style="display: flex; justify-content: right; width: 50%; gap: 10px;">
                            <span style="float: right;" class="pointer header-close-btn" matTooltipClass="mat-tooltip-custom" matTooltip="Close"
                              matTooltipPosition="below" (click)="toggleSidebar(false,'decline')">
                              <mat-icon style="color: white;" >close</mat-icon>
                            </span>
                          </div>
                        </div>

                        <div class="sidebar-content">

                          <mat-form-field class="full-width" color="accent">
                            <mat-label>Select a reason for declining</mat-label>
                            <mat-select [(ngModel)]="declineReason" (selectionChange)="onDeclineReasonChange($event)">
                              <mat-option *ngFor="let item of delineReasonData" [value]="item.id"> {{item.reasonDescription}}</mat-option>
                            </mat-select>
                          </mat-form-field>

                          <mat-form-field class="full-width" color="accent" *ngIf="showOtherReason">
                            <mat-label>Other Reason</mat-label>
                            <input matInput [(ngModel)]="otherReason" placeholder="Other reason">
                        </mat-form-field>




                            <div class="button-container">
                                <button type="button" class="save-button" (click)="declineLineItem()">
                                    <mat-icon>save</mat-icon>
                                </button>
                                <button type="button" class="close-button" (click)="toggleSidebar(false,'decline')">
                                    <mat-icon>cancel</mat-icon>
                                </button>
                            </div>
                        </div>
                      </div> -->


                  </div>
              </mat-card-content>
          </mat-card>
      </div>
  </div>








<!-- Popup for confirmation -->
<!-- <div class="namemodal" *ngIf="showConfirmationDialogue">
    <div class="modalContent">
        <div class="p-6 text-center">
            <div class="flex justify-center mb-4">
                <div class="bg-orange-100 rounded-full w-20 h-20 flex items-center justify-center">
                    <mat-icon class="text-orange-600"
                        style="font-size: 40px;  height:100%; width:100%;">warning</mat-icon>
                </div>
            </div>
            <h2 class="text-xl font-bold mb-2">Are you sure?</h2>
            <p class="mb-6">Are you sure you want to leave this page?<br>Any unsaved attachments will be lost if you leave. Please save them or finish the process in another tab</p>
            <div class="flex justify-center gap-4">
                <button mat-raised-button color="primary" (click)="confirm()">Yes</button>
                <button mat-stroked-button (click)="cancel()">Cancel</button>
            </div>
        </div>

    </div>
  </div> -->


<!-- Popup for confirmation -->
<!-- <div class="namemodal" *ngIf="showCloseDialogue">
        <div class="modalContent">
            <div class="p-6 text-center">
                <div class="flex justify-center mb-4">
                    <div class="bg-orange-100 rounded-full w-20 h-20 flex items-center justify-center">
                        <mat-icon class="text-orange-600"
                            style="font-size: 40px;  height:100%; width:100%;">warning</mat-icon>
                    </div>
                </div>
                <h2 class="text-xl font-bold mb-2">Are you sure?</h2>
                <p class="mb-6">Are you sure you want to save this RFQ as draft?</p>
                <div class="flex justify-center gap-4">
                    <button mat-raised-button color="primary" (click)="save()">Save as draft</button>
                    <button mat-stroked-button (click)="goToRfqCart()">Cancel</button>
                </div>
            </div>

        </div>
    </div> -->
    <!-- Popup for confirmation -->
    <div class="namemodal" *ngIf="showCloseDialogue">
        <div class="modalContent">
            <div class="p-6 text-center">
                <div class="flex justify-center mb-4">
                    <div class="bg-orange-100 rounded-full w-20 h-20 flex items-center justify-center">
                        <mat-icon class="text-orange-600"
                            style="font-size: 40px;  height:100%; width:100%;">warning</mat-icon>
                    </div>
                </div>
                <!-- <h2 class="text-xl font-bold mb-2">You want to save this as draft?</h2> -->
                <p class="mb-6">You want to save this as draft?</p>
                <div class="flex justify-center gap-4">
                    <button mat-raised-button color="primary" (click)="save(true)" style="margin-right: 5px;">YES</button>
                    <button mat-stroked-button (click)="cancel()" style="margin-left:5px">NO</button>
                </div>
            </div>

        </div>
    </div>

    <div class="namemodal" *ngIf="showCloseDialogueFreight">
        <div class="modalContent">
            <div class="p-6 text-center">
                <div class="flex justify-center mb-4">
                    <div class="bg-orange-100 rounded-full w-20 h-20 flex items-center justify-center">
                        <mat-icon class="text-orange-600"
                            style="font-size: 40px;  height:100%; width:100%;">warning</mat-icon>
                    </div>
                </div>
                <!-- <h2 class="text-xl font-bold mb-2">You want to save this as draft?</h2> -->
                <p class="mb-6">Are you sure you want to cancel?</p>
                <div class="flex justify-center gap-4">
                    <button mat-raised-button color="primary" (click)="saveFreightForwarder()" style="margin-right: 5px;">YES</button>
                    <button mat-stroked-button (click)="cancel()" style="margin-left:5px">NO</button>
                </div>
            </div>

        </div>
    </div>


    <!-- Freight Forwarder Selection Modal -->
  <!-- <div class="namemodal" *ngIf="showFreightForwarderDialogue">
    <div class="modalContent">
      <div class="p-6 text-center" [formGroup]="freightForwarderForm">
        <p class="text-lg font-semibold mb-4">
          Please select the Freight Forwarder <span class="text-red-600">*</span>
        </p>


        <mat-form-field appearance="outline" class="w-full">
          <mat-label>Freight Forwarder Company Name</mat-label>
          <mat-select formControlName="freightForwarderId" (selectionChange)="onFreightForwarderSelected($event.value)">
            <mat-option *ngFor="let forwarder of freightForwarders" [value]="forwarder.id">
              {{ forwarder.freightForwarderCompanyName }}
            </mat-option>
          </mat-select>
        </mat-form-field>


        <div class="form-item-row" style="align-items: center; gap: 8px;">
          <mat-form-field appearance="outline" class="w-full" style="margin-top: 12px;">
            <mat-label>Mode of Transport</mat-label>
            <mat-select formControlName="modeOfTransport" [disabled]="!freightForwarderForm.get('freightForwarderId')?.value || availableModes.length === 0">
              <mat-option *ngFor="let transport of availableModes" [value]="transport.id">
                {{ transport.modeOfTransport }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <button mat-icon-button (click)="toggleSubSideBar(true, 'modeOfTransport')" [disabled]="!freightForwarderForm.get('freightForwarderId')?.value" matTooltip="Add Mode of Transport">
            <mat-icon>add</mat-icon>
          </button>
        </div>


        <div class="form-item-row" style="align-items: center; gap: 8px;">
          <mat-form-field appearance="outline" class="w-full" style="margin-top: 12px;">
            <mat-label>Packaging</mat-label>
            <mat-select formControlName="packaging" [disabled]="!freightForwarderForm.get('freightForwarderId')?.value || availablePackaging.length === 0">
              <mat-option *ngFor="let packaging of availablePackaging" [value]="packaging.id">
                {{ packaging.packagingType }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <button mat-icon-button (click)="toggleSubSideBar(true, 'packaging')" [disabled]="!freightForwarderForm.get('freightForwarderId')?.value" matTooltip="Add Packaging">
            <mat-icon>add</mat-icon>
          </button>
        </div>

        <div class="flex justify-center gap-4 mt-6">
          <button mat-raised-button color="primary" (click)="confirmFreightForwarder()" [disabled]="freightForwarderForm.invalid">OK</button>
        </div>
      </div>
    </div>
  </div> -->

  <div class="freightForwarderNamemodal" *ngIf="showFreightForwarderDialogue">
  <div class="modalContent">
    <div class="p-6 text-center" [formGroup]="freightForwarderForm">
      <p class="text-lg font-semibold mb-15">
        Please select the Freight Forwarder <span class="text-red-600">*</span>
      </p>

      <!-- Freight Forwarder -->
      <mat-form-field appearance="outline" class="w-full">
        <mat-label>Freight Forwarder Company Name</mat-label>
        <mat-select
          formControlName="freightForwarderId"
          (selectionChange)="onFreightForwarderSelected($event.value)"
        >
          <mat-option
            *ngFor="let forwarder of freightForwarders"
            [value]="forwarder.id"
          >
            {{ forwarder.freightForwarderCompanyName }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Mode of Transport -->
      <div class="inline-field-row">
        <mat-form-field appearance="outline" class="flex-grow">
          <mat-label>Mode of Transport</mat-label>
          <mat-select
            formControlName="modeOfTransportId"
            (selectionChange)="onModeOfTransportCheckBoxChange($event)"
            [disabled]="
              !freightForwarderForm.get('freightForwarderId')?.value ||
              availableModes.length === 0
            "
          >
            <mat-option
              *ngFor="let transport of availableModes"
              [value]="transport.id"
            >
              {{ transport.modeOfTransport }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <button
          mat-icon-button
          class="add-modeOfTransport-packaging-btn"
          (click)="toggleSubSideBar(true, 'modeOfTransport')"
          [disabled]="!freightForwarderForm.get('freightForwarderId')?.value"
          matTooltip="Add Mode of Transport"
        >
          <mat-icon>add</mat-icon>
        </button>
      </div>

      <!-- Packaging -->
      <div class="inline-field-row">
        <mat-form-field appearance="outline" class="flex-grow">
          <mat-label>Packaging</mat-label>
          <mat-select
            formControlName="packagingId"
            (selectionChange)="onPackagingCheckBoxChange($event)"
            [disabled]="
              !freightForwarderForm.get('freightForwarderId')?.value ||
              availablePackaging.length === 0
            "
          >
            <mat-option
              *ngFor="let packaging of availablePackaging"
              [value]="packaging.id"
            >
              {{ packaging.packagingType }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <button
          mat-icon-button
          class="add-modeOfTransport-packaging-btn"
          (click)="toggleSubSideBar(true, 'packaging')"
          [disabled]="!freightForwarderForm.get('freightForwarderId')?.value"
          matTooltip="Add Packaging"
        >
          <mat-icon>add</mat-icon>
        </button>
      </div>

      <div class="flex justify-center gap-4 mt-6">
        <button
          mat-raised-button
          color="primary"
          (click)="confirmFreightForwarder()"
          [disabled]="freightForwarderForm.invalid"
        >
          OK
        </button>
      </div>
    </div>
  </div>
</div>

</div>


<div
    class="sidebar"
    [class.open]="showSubSidebar && currentSubForm === 'modeOfTransport'"
  >
    <div class="sidebar-title">
      <div class="sidebar-title-text">Add Mode of Transport</div>
    </div>
    <form [formGroup]="modeOfTransportFormGroup">
        <div class="sidebar-content">
          <mat-form-field appearance="fill" class="full-width">
            <mat-label>Mode of Transport</mat-label>
            <input matInput placeholder="Name of Mode of Transport" formControlName="modeOfTransport"/>
          </mat-form-field>

            <div class="button-container">
              <button
                type="button"
                class="save-button"
                (click)="saveForm('modeOfTransport')"
              >
                <mat-icon>save</mat-icon>
              </button>
              <button
                type="button"
                class="close-button"
                (click)="toggleSubSideBar(false, 'modeOfTransport')"
              >
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
    </form>

  </div>

  <div
    class="sidebar"
    [class.open]="showSubSidebar && currentSubForm === 'packaging'"
  >
    <div class="sidebar-title">
      <div class="sidebar-title-text">Add Packaging</div>
    </div>
    <form [formGroup]="packagingFormGroup">
        <div class="sidebar-content">
          <mat-form-field appearance="fill" class="full-width">
            <mat-label>Packaging</mat-label>
            <input matInput placeholder="Name of Packaging" formControlName="packaging"/>
          </mat-form-field>

            <div class="button-container">
              <button
                type="button"
                class="save-button"
                (click)="saveForm('packaging')"
              >
                <mat-icon>save</mat-icon>
              </button>
              <button
                type="button"
                class="close-button"
                (click)="toggleSubSideBar(false, 'packaging')"
              >
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
    </form>

  </div>

<!-- Custom Notification for Missing Fields -->
<div *ngIf="showNotification"
     class="notification-popup"
     [ngClass]="{'error-notification': notificationType === 'error', 'info-notification': notificationType === 'info', 'show': showNotification, 'hide': !showNotification}">
  <div class="notification-content">
    <div class="flex justify-center mb-4">
        <div class="bg-orange-100 rounded-full w-20 h-20 flex items-center justify-center">
            <mat-icon class="text-orange-600"
                style="font-size: 75px;  height:100%; width:100%;">warning</mat-icon>
        </div>
    </div>
    <div class="notification-message" [innerHTML]="notificationMessage"></div>
    <button (click)="dismissNotification()" class="btn-ok">OK</button>
  </div>
</div>



<div class="carousel-container" *ngIf="previewSection">
  <div class="carousel-close-button" style="display: flex; flex-direction: row; gap: 10px;">
  <button class="image-close-button" (click)="togglePreview(false,'')">
      <mat-icon style="font-size:20px">cancel</mat-icon>
  </button>
  </div>
  <div class="carousel">
  <button class="carousel-control prev" (click)="prevSlide()">
      &#10094;
  </button>

  <div class="carousel-image-container">
      <div
      class="headerattachmentcarouselimageContainerInner"
      *ngIf="isPdf(previewDocs[currentIndex])"
      >
          <pdf-viewer
          [src]="previewDocs[currentIndex]"
          [render-text]="false"
          [page]="1"
          [show-all]="true"
          [original-size]="false"
          class="content"
          >
          </pdf-viewer>
      </div>
      <div
      class="headerattachmentimage-container-inner"
      *ngIf="!isPdf(previewDocs[currentIndex])"
      >
          <img
          [src]="previewDocs[currentIndex]"
          [alt]="'headerattachment image'"
          class="carousel-image"
          />
      </div>
  </div>

  <button class="carousel-control next" (click)="nextSlide()">
      &#10095;
  </button>
  </div>
</div>
